import { useContext } from "react";
import { AuthContext } from "../Authorization/AuthContext";
import { Switch } from "../Inputs";
import { DataRow, Header, Section, Toggle } from "./__styles__/Settings";

interface DisplaySettingsProps {
  hiddenFromPublic: boolean;
  authorized: boolean;
  onChange: () => void;
  loading: boolean;
}

const DisplaySettings = ({
  hiddenFromPublic,
  authorized,
  onChange,
  loading,
}: DisplaySettingsProps) => {
  const { account } = useContext(AuthContext);
  if (!account?.publicPortal.enabled) return null;

  return (
    <Section>
      <Header>Display Settings</Header>
      <DataRow>
        <div>Display file on public website?</div>
        <Toggle>
          <Switch
            name="displayToggle"
            onChange={onChange}
            value={!hiddenFromPublic}
            size="tiny"
            disabled={loading || !authorized}
          />
        </Toggle>
      </DataRow>
    </Section>
  );
};

export default DisplaySettings;
